import React, { Component } from 'react';
import './button-floating.styles.css';

class ButtonFloating extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visivel: true,
            right: props.right !== undefined ? props.right : '30px',
            bottom: props.bottom !== undefined ? props.bottom : '30px',
            width: props.width !== undefined ? props.width : '60px',
            left: props.left,
            top: props.top
        }
    }

    visibilidade() {
        this.setState({
            visivel: !this.state.visivel
        });
    }

    render() {
        let iconClass = this.props.iconClass !== undefined ? this.props.iconClass : "fas fa-bars";

        return <div
            className="mv-floating-button-container" style={{ right: this.state.right, bottom: this.state.bottom, left: this.state.left, top: this.state.top,
                width: this.state.width }}>
            <a className={"mv-floating-button button" + (this.props.sm !== undefined ? " sm" : "") + (this.props.disabled ? " disabled" : "")} onClick={() => {
                if (!this.props.disabled) {
                    if (typeof (this.props.onClick) === "function") {
                        this.props.onClick();
                    } else {
                        this.visibilidade();
                    }
                }
            }}>
                <i className={this.state.visivel
                    ? (this.props.iconClose !== undefined ? this.props.iconClose : "fas fa-times") + (this.props.sm === undefined ? " fa-lg" : "")
                    : (this.props.iconOpen !== undefined ? this.props.iconOpen : iconClass) + (this.props.sm === undefined ? " fa-lg" : "")}>
                </i>
            </a>
            <ul className={this.state.visivel ? 'visivel' : undefined}>
                {
                    this.props.actions !== undefined && this.props.actions.map((item, i) => {
                        return <li key={i}>
                            <a className="mv-floating-button inner-button"
                                style={{ backgroundColor: item.backgroundColor, color: item.color }}
                                onClick={item.onClick}>
                                {item.className !== undefined ? <i className={item.className}></i> : item.label}
                            </a>
                            <p className="mv-floating-button texto">
                                {`${item.texto}${item.atalho ? ` (${item.atalho})` : item.totalizador ? ` (${item.totalizador})` : ``}`}
                            </p>
                        </li>
                    })
                }
            </ul>
        </div>
    }
}

export default ButtonFloating;


// WEBPACK FOOTER //
// ./src/componentes/button/button-floating.component.js